"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OptionsType;
(function (OptionsType) {
    OptionsType["SERVICE_PLAN"] = "service plan";
    OptionsType["ACCESSORIES_PACK"] = "accessories pack";
    OptionsType["ACCESSORIES"] = "accessories";
    OptionsType["GOVERNMENT_CHARGES"] = "gov_charges";
})(OptionsType = exports.OptionsType || (exports.OptionsType = {}));
